import { isUserLogin } from '@/utilities/CheckUserIsLogin';
import { messaging } from '@/utilities/firebaseClient';

import { setFCMTokenService } from '@/client/services/core/user/methods';
import { getToken, MessagePayload, onMessage } from 'firebase/messaging';

let isOnMessageRegistered = false;

const resolveNotificationLink = (link?: string) => {
    if (!link || typeof window === 'undefined') {
        return undefined;
    }

    try {
        return new URL(link, window.location.origin).href;
    } catch {
        return undefined;
    }
};

const registerForegroundMessageHandler = () => {
    if (!messaging || isOnMessageRegistered) {
        return;
    }

    isOnMessageRegistered = true;

    onMessage(messaging, (payload: MessagePayload) => {
        const notificationPayload = payload.notification || {};
        const dataPayload = payload.data || {};
        const title = notificationPayload.title || dataPayload.title || '';
        const body = notificationPayload.body || dataPayload.body || '';
        const image = notificationPayload.image || dataPayload.image;
        const link = resolveNotificationLink(dataPayload.link || payload.fcmOptions?.link);

        if (!title && !body) {
            return;
        }

        if (typeof Notification === 'undefined' || Notification.permission !== 'granted') {
            return;
        }

        navigator.serviceWorker.ready
            .then((registration) =>
                registration.showNotification(title, {
                    tag: payload.messageId,
                    body,
                    icon: '/favicon.ico',
                    // @ts-expect-error type error
                    image,
                    data: {
                        link
                    }
                })
            )
            .catch((error) => console.error('Foreground notification failed:', error));
    });
};

export const isPushNotificationSupported = () => typeof window !== 'undefined' && typeof Notification !== 'undefined' && 'serviceWorker' in navigator;

export const registerClientPushToken = async () => {
    if (!isPushNotificationSupported() || !messaging || !isUserLogin() || Notification.permission !== 'granted') {
        return;
    }

    registerForegroundMessageHandler();

    try {
        const registration = await navigator.serviceWorker.ready;
        const token = await getToken(messaging, { vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY, serviceWorkerRegistration: registration });
        return await setFCMTokenService(token);
    } catch (error) {
        console.error('Push token registration failed:', error);
    }
};

export const requestClientPushNotification = async () => {
    if (!isPushNotificationSupported() || !messaging) {
        return;
    }

    if (Notification.permission === 'default') {
        await Notification.requestPermission();
    }

    return await registerClientPushToken();
};
